import { getIconComponent } from "@raiden/library/components/Icon";

export const Icon = getIconComponent({
  defaultSize: "1rem",
  defaultLightColor: "gray.800",
  defaultDarkColor: "whiteAlpha.900",
});
